import { InputGroup } from '@/components/InputGroup'
import { FormLabel, Grid, InputRightAddon, Stack, Text } from '@chakra-ui/react'
import type { Discount } from 'BrokerTsLib/src/dtos'
import { useEffect, useState } from 'react'

const CheckboxDiscount = ({
  discount,
  onChange
}: {
  discount: Discount,
  onChange: (value?: number) => void
}) => {

  const [discountValue, setDiscountValue] = useState(discount.discount)
  useEffect(() => {
    if (discount.discount != discountValue)
      setDiscountValue(discount.discount)
  }, [discount.discount])

  return (
    <Grid
      key={discount.insuranceCategoryDiscountId}
      templateColumns='1fr 1fr'
    >
      <Stack gap={1}>
        <FormLabel>
          {discount.name}
        </FormLabel>

        <Text
          fontSize='2xs'>
          (max: {discount.maxDiscount}{discount.unit})
        </Text>
      </Stack>

      <InputGroup
        variant='filled'
        size='md'
        type='number'
        sx={{ fontSize: 'md', fontWeight: 'bold' }}
        backgroundColor='white'
        value={discountValue ?? ''}
        rightElement={<InputRightAddon>{discount.unit}</InputRightAddon>}
        onChange={(e) => {
          const parsed = e.target.value ? parseInt(e.target.value) : undefined

          discount.discount = parsed
          setDiscountValue(parsed)
          onChange(parsed)
        }}
      />
    </Grid>
  )
}

export default CheckboxDiscount